import React from "react";
import time1 from '../../assests/images/timemember1.png'
import time2 from '../../assests/images/timemember2.png'
import time3 from '../../assests/images/timemember3.png'
import time4 from '../../assests/images/timemember4.png'
import Mailbox from '../../assests/images/image -9-.png'

const teamMembers = [
  {
    name: "Leron Walton",
    title: "Chief Analytics Officer",
    image: time1,
    featured: false,
  },
  {
    name: "Leron Walton",
    title: "Chief Analytics Officer",
    image: time2,
    featured: false,
  },
  {
    name: "Leron Walton",
    title: "Chief Analytics Officer",
    image: time3,
    featured: true, // blue background
  },
  {
    name: "Leron Walton",
    title: "Chief Analytics Officer",
    image: time4,
    featured: false,
  },
];

const OurAwesomeTeam = () => {
  return (
    <div className="px-6 lg:max-w-7xl mx-auto lg:px-14 lg:py-2 py-8 bg-white">
      {/* <section className="relative lg:mt-48 mt-4 px-4">
        <div className="bg-[#2B80B9] text-white rounded-3xl py-10 px-6 md:px-16 text-center lg:max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
          <div className="flex-1 lg:ml-[150px]">
            <h3 className="text-[44px] 2xl:text-[26px] lg:text-[20px] font-recoleta mb-6" data-aos="fade-up">
              Subscribe to our newsletter
            </h3>
            <form className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <input
                type="email"
                data-aos="fade-up"
                placeholder="Enter your email"
                className="px-6 py-3 rounded-full outline-none lg:w-[260px] border-2 border-[#f56944] bg-[#f56944] text-white placeholder-white font-medium"
              />
              <button
              data-aos="fade-up"
                type="submit"
                className=" bg-white text-[#09588D] 2xl:text-[20px] lg:text-[16px] 2xl:w-40 lg:w-28 h-[53px] px-6 py-3 rounded-full font-semibold shadow-md hover:bg-gray-100"
              >
               <span> Send</span>
              </button>
            </form>
          </div>
          <div className="hidden md:block flex-shrink-0 mr-[-30px] mt-[-270px]">
            <img src={Mailbox} alt="Mailbox" className="w-[370px] lg:block hidden h-[270px]" data-aos="fade-left" />
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default OurAwesomeTeam;
